import { createSlice } from "@reduxjs/toolkit";

export interface SharedState {
    showLoading: boolean;
    iller: Array<any>;
    ilceler: Array<any>;
    mahalleler: Array<any>;
    tapuIller: Array<any>;
    tapuIlceler: Array<any>;
    tapuMahalleler: Array<any>;
    goLocation: boolean;
    style: string;
    labeling: number,
    functionalRoles: Array<any>;
    zoneRoles: Array<any>;
    dataRoles: Array<any>;
    user: any,
    parcelSearchClicked: boolean;
    selectedParcelRapor: any
    osbler: any
    refreshLayers: any,
    legend: {
        url: string,
        text: string
    },
    tableRow: any,
    userGroups: any,
    userGroup: any
}

const initialState: SharedState = {
    showLoading: false,
    iller: [],
    ilceler: [],
    mahalleler: [],
    tapuIller: [],
    tapuIlceler: [],
    tapuMahalleler: [],
    goLocation: false,
    style: 'parsel_usr',
    labeling: 0,
    functionalRoles: [],
    zoneRoles: [],
    dataRoles: [],
    user: null,
    parcelSearchClicked: false,
    selectedParcelRapor: null,
    osbler: null,
    refreshLayers: null,
    legend: {
        url: '',
        text: ''
    },
    tableRow: undefined,
    userGroups: [],
    userGroup: {}
};

export const sharedSlice = createSlice({
    name: 'sharedState',
    initialState,
    reducers: {
        setShowLoading: (state: SharedState, action) => {
            state.showLoading = action.payload;
        },
        setIller: (state: SharedState, action) => {
            state.iller = action.payload;
        },
        setIlceler: (state: SharedState, action) => {
            state.ilceler = action.payload;
        },
        setMahalleler: (state: SharedState, action) => {
            state.mahalleler = action.payload;
        },
        setTapuIller: (state: SharedState, action) => {
            state.tapuIller = action.payload;
        },
        setTapuIlceler: (state: SharedState, action) => {
            state.tapuIlceler = action.payload;
        },
        setTapuMahalleler: (state: SharedState, action) => {
            state.tapuMahalleler = action.payload;
        },
        setGoLocation: (state: SharedState, action) => {
            state.goLocation = action.payload;
        },
        setStyle: (state: SharedState, action) => {
            state.style = action.payload;
        },
        setFunctionalRoles: (state: SharedState, action) => {
            state.functionalRoles = action.payload;
        },
        setZoneRoles: (state: SharedState, action) => {
            state.zoneRoles = action.payload;
        },
        setDataRoles: (state: SharedState, action) => {
            state.dataRoles = action.payload;
        },
        setUser: (state: any, action) => {
            state.user = action.payload;
        },
        setSelectedParcelRapor: (state: SharedState, action) => {
            state.selectedParcelRapor = action.payload;
        },
        setOsbler: (state: SharedState, action) => {
            state.osbler = action.payload;
        },
        setRefreshLayers: (state: SharedState, action) => {
            state.refreshLayers = action.payload;
        },
        setLegend: (state: SharedState, action) => {
            state.legend = action.payload;
        },
        setSelectedRow: (state: SharedState, action) => {
            state.tableRow = action.payload;
        },
        setUserGroups: (state: any, action) => {
            state.userGroups = action.payload;
        },
        setUserGroup: (state: any, action) => {
            state.userGroup = action.payload;
        }

    }
})

export const { setShowLoading, setIller, setIlceler, setMahalleler, setUser, setGoLocation, setStyle, setFunctionalRoles, setZoneRoles,
    setTapuIller, setTapuIlceler, setTapuMahalleler, setSelectedParcelRapor, setOsbler, setRefreshLayers, setSelectedRow,
    setLegend, setDataRoles, setUserGroups, setUserGroup } = sharedSlice.actions;
export default sharedSlice.reducer;